export default {"src":"/_next/static/media/ic-Success.f7eb1dae.svg","height":63,"width":64,"blurWidth":0,"blurHeight":0};